// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3SBHd","inner":"Footer_inner__1kZU3"};